// Re-authentication page (#reauth-root): the interstitial a non-HTMX
// navigation lands on when the access JWT has expired but a refresh token
// may still be valid. Try one refresh, then send the browser on to the
// original destination, or to the login page the server names.
import { refresh } from "./session-refresh.js";

function go(url) {
  window.location.replace(url || "/auth/login");
}

function reauthenticate() {
  const root = document.getElementById("reauth-root");
  if (!root) return;
  const next = root.dataset.next || "/";
  const loginUrl = root.dataset.loginUrl || "/auth/login";
  refresh()
    .then((resp) => {
      if (resp.ok) {
        go(next);
        return;
      }
      go(resp.headers.get("HX-Redirect") || loginUrl);
    })
    .catch(() => go(loginUrl));
}

reauthenticate();
